export const titleColumn = {
  cell: (info) => {
    const row = info.row.original;
    return (
      <div className="tooltip flex flex-row" data-tip={info.getValue()}>
        {info.row.index + 1}
        <a
          href={`https://pubmed.ncbi.nlm.nih.gov/${row.pmid}/`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
          className="ml-2 text-blue-600 underline hover:text-blue-800"
        >
          {info.getValue()}
        </a>
      </div>
    );
  },
  header: () => <span>Publication</span>,
  size: 400,
  meta: { className: "min-w-[400px] max-w-[400px]" },
};

export const pmidColumn = {
  id: "pmid",
  cell: (info) => info.getValue(),
  header: () => (
    <span className="block w-full break-words whitespace-pre-line">PMID</span>
  ),
  size: 100,
  meta: { className: "min-w-[100px] max-w-[100px]" },
};

export const searchTermColumn = {
  id: "searchTerm",
  cell: (info) => info.getValue(),
  header: () => (
    <span className="block w-full break-words whitespace-pre-line">
      Search term
    </span>
  ),
  size: 200,
  meta: { className: "min-w-[200px] max-w-[200px]" },
};

export const relevanceColumn = {
  id: "relevance",
  cell: (info) => (
    <div
      className={`badge badge-soft w-full text-center ${info.getValue() === "Relevant" ? "badge-success" : "badge-error"}`}
    >
      {info.getValue()}
    </div>
  ),
  header: () => (
    <span className="block w-full break-words whitespace-pre-line">
      Relevance
    </span>
  ),
  size: 150,
  meta: { className: "min-w-[150px] max-w-[150px]" },
};

export const subjectPopulationColumn = {
  id: "subject_population",
  cell: (info) => info.getValue(),
  header: () => <span>Subject population</span>,
  size: 500,
  meta: { className: "min-w-[500px] max-w-[500px]" },
};

export const safetyColumn = {
  id: "safety",
  cell: (info) => info.getValue(),
  header: () => <span>Safety</span>,
  size: 150,
  meta: { className: "min-w-[150px] max-w-[150px]" },
};

export const remarksColumn = {
  id: "remarks",
  cell: (info) => info.getValue(),
  header: () => <span>Remarks</span>,
  size: 400,
  meta: { className: "min-w-[400px] max-w-[400px]" },
};

export const claimsColumn = {
  id: "claims",
  cell: (info) => info.getValue(),
  header: () => <span>Claims</span>,
  size: 500,
  meta: { className: "min-w-[500px] max-w-[500px]" },
};

export const f1ScoreColumn = {
  id: "f1_score",
  cell: (info) => <div className="w-full text-center">{info.getValue()}</div>,
  header: () => (
    <span className="block w-full text-center break-words whitespace-pre-line">
      F1 Score
    </span>
  ),
  size: 110,
  meta: { className: "min-w-[110px] max-w-[110px]" },
};
export const f2ScoreColumn = {
  id: "f2_score",
  cell: (info) => <div className="w-full text-center">{info.getValue()}</div>,
  header: () => (
    <span className="block w-full text-center break-words whitespace-pre-line">
      F2 Score
    </span>
  ),
  size: 110,
  meta: { className: "min-w-[110px] max-w-[110px]" },
};
export const claimsPopulationSubjectRelvantColumn = {
  id: "claims_population_subject_relvant",
  cell: (info) => (
    <div
      className={`badge badge-soft w-full text-center ${info.getValue() ? "badge-success" : "badge-error"}`}
    >
      {info.getValue() ? "Yes" : "No"}
    </div>
  ),
  header: () => (
    <span className="block w-full text-center break-words whitespace-pre-line">
      Article Relevancy
    </span>
  ),
  size: 170,
  meta: { className: "min-w-[170px] max-w-[170px]" },
};
